// declare var readImageUrl: (input: HTMLInputElement) => void

import { readImageUrl } from '@/javascript/legacy/image-helper'

type Props = {
  values: {
    title: string
    description: string
    details: string
  }
  images?: File[]
}

export const fillLegacyTicketForm = ({ values, images }: Props) => {
  const titleEl = document.querySelector<HTMLTextAreaElement>('#ticket_title')
  const descriptionEl = document.querySelector<HTMLTextAreaElement>('#ticket_description')
  const detailsEl = document.querySelector<HTMLTextAreaElement>('#ticket_details')
  const attachmentEl = document.querySelector<HTMLInputElement>('input[name="ticket[attachments_attributes][0][file]"]')
  const attachmentsDropzoneEl = document.querySelector<HTMLElement>('#ticket-attachments-dropzone')
  const attachmentsDropzone = (attachmentsDropzoneEl as any)?.dropzone || null
  const attachmentCount = attachmentsDropzone ? attachmentsDropzone.getAcceptedFiles().length : (attachmentEl?.files?.length || 0)
  const hasValues = titleEl.value || descriptionEl.value || detailsEl.value || attachmentCount > 0
  if (hasValues && !confirm('O conteúdo dos campos preenchidos será alterado ao utilizar a IA.\n\nDeseja continuar?')) return
  titleEl!.value = values.title
  descriptionEl!.value = values.description
  detailsEl!.value = values.details
  if (images && images.length > 0) {
    if (attachmentsDropzone) {
      attachmentsDropzone.removeAllFiles(true)
      images.forEach((file: File) => {
        attachmentsDropzone.addFile(file)
      })
    } else {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(images[0])
      attachmentEl!.files = dataTransfer.files
      readImageUrl(attachmentEl!)
    }
  }
}
